import { inject, Injectable } from '@angular/core';
import { SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';
import { FinancialAccountTypes } from '../models/financial-account-models';

const STORAGE_KEY_PREFIX = 'patriot_act_notice_shown';

/** Savings and Spending account opening flows require the Patriot Act notice once per session. */
export type PatriotActAccountType = FinancialAccountTypes.SAVINGS | FinancialAccountTypes.SPENDING;

@Injectable({ providedIn: 'root' })
export class PatriotActNoticeService {
  private readonly _modalSvc = inject(SimpleGlobalModalService);

  hasSeenNotice(): boolean {
    return sessionStorage.getItem(STORAGE_KEY_PREFIX) === 'true';
  }

  /**
   * Presents the Patriot Act notice before continuing when it has not yet been shown
   * for this product in the current browser session.
   */
  continueAfterNoticeIfNeeded(accountType: PatriotActAccountType, onContinue: () => void): void {
    if (this.hasSeenNotice()) {
      onContinue();
      return;
    }

    this._modalSvc.createModal({
      title: 'patriot_act_notice_title',
      contentKey: 'patriot_act_notice_desc',
      displayCloseButton: false,
      eventName: 'patriot_act_notice',
      isError: false,
      size: 'large',
      ctaKey: 'BUTTON_CONTINUE',
      ctaAction: () => {
        sessionStorage.setItem(STORAGE_KEY_PREFIX, 'true');
        onContinue();
      },
    });
  }
}
